/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formattachment_Quantityvalidation2Inputs */

const ja_contact_formattachment_quantityvalidation2 = /** @type {(inputs: Contact_Formattachment_Quantityvalidation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添付できるファイルは、2つまでです。`)
};

const en_contact_formattachment_quantityvalidation2 = /** @type {(inputs: Contact_Formattachment_Quantityvalidation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, We only allow 2 attachments.`)
};

/**
* | output |
* | --- |
* | "Sorry, We only allow 2 attachments." |
*
* @param {Contact_Formattachment_Quantityvalidation2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formattachment_quantityvalidation2 = /** @type {((inputs?: Contact_Formattachment_Quantityvalidation2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formattachment_Quantityvalidation2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formattachment_quantityvalidation2(inputs)
	return en_contact_formattachment_quantityvalidation2(inputs)
});
export { contact_formattachment_quantityvalidation2 as "contact_formAttachment_quantityValidation" }